export default __webpack_public_path__ + "static/mobile_landing-winter-f9c3a24052bbf8a152fa4073e9597b1d.png";